// Tiny fetch-based client with an axios-like shape ({ data }).
// Kept intentionally light (no heavy HTTP library) so the app stays fast on
// slow connections.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

async function request(method, path, body) {
  const headers = {};
  const opts = { method, headers, credentials: "include" };
  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(body);
  }
  let res;
  try {
    res = await fetch(`${API}${path}`, opts);
  } catch (e) {
    const err = new Error("network");
    err.isNetwork = true;
    throw err;
  }
  let data = null;
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  if (!res.ok) {
    const err = new Error("http_" + res.status);
    err.response = { status: res.status, data };
    throw err;
  }
  return { data, status: res.status };
}

const api = {
  get: (path) => request("GET", path),
  post: (path, body) => request("POST", path, body),
  put: (path, body) => request("PUT", path, body),
  del: (path) => request("DELETE", path),
};

export function friendlyError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (err?.isNetwork)
    return "We could not reach the shop right now. Check your signal and try again.";
  return "That did not work this time. Please try again in a moment.";
}

export default api;
